import { render, staticRenderFns } from "./LiveBadge.vue?vue&type=template&id=01e599a0&scoped=true"
import script from "./LiveBadge.vue?vue&type=script&lang=js"
export * from "./LiveBadge.vue?vue&type=script&lang=js"
import style0 from "./LiveBadge.vue?vue&type=style&index=0&id=01e599a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e599a0",
  null
  
)

export default component.exports